/* rx-builder.js — stepped Rx builder.
   Steps 1, 2 and 4 are complete. Step 3 supports Manual and Send later; Upload is blocked
   on the Uploadery decision and its Continue stays disabled so nothing can be ordered
   without a prescription path. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rx-builder]');
  if (!root) return;

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-rx-variants]').textContent); } catch (e) { return; }
  if (!variants.length) return;

  var TRIVEX_ID = parseInt(root.getAttribute('data-trivex-variant'), 10) || 0;
  var TRIVEX_PRICE = parseInt(root.getAttribute('data-trivex-price'), 10) || 0;
  var MONEY = root.getAttribute('data-money-format') || '${{amount}}';

  var state = {
    step: 1,
    use: null,          // Distance | Reading | Progressive
    type: null,         // Single Vision | Progressive  (option 1)
    color: null,        // option 2
    material: 'Polycarbonate',
    method: null,       // Upload | Manual | Send later
    pdType: 'Single',
    attest: false,      // "I confirm ..." box on the manual path
    values: {}          // manual Rx + PD values
  };

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return MONEY.indexOf('{{amount}}') > -1 ? MONEY.replace('{{amount}}', n) : '$' + n;
  }

  /* ---------- variant helpers ---------- */
  function colorsFor(type) {
    var seen = {}, out = [];
    variants.forEach(function (v) {
      if (v.type !== type) return;
      if (seen[v.color]) return;
      seen[v.color] = 1; out.push(v);
    });
    return out;
  }
  function find(type, color) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].type === type && variants[i].color === color) return variants[i];
    }
    return null;
  }
  function cheapest(type) {
    var best = null;
    variants.forEach(function (v) { if (v.type === type && (!best || v.price < best.price)) best = v; });
    return best;
  }
  function current() { return (state.type && state.color) ? find(state.type, state.color) : null; }

  function total() {
    var v = current();
    if (!v) return null;
    return v.price + (state.material === 'Trivex' ? TRIVEX_PRICE : 0);
  }

  /* ---------- option ranges ---------- */
  function range(from, to, step, fmt) {
    var out = [], n = from;
    // step with integers to avoid float drift (-20.00 .. +12.00 at 0.25)
    var mul = 100, f = Math.round(from * mul), t = Math.round(to * mul), s = Math.round(step * mul);
    out = [];
    for (n = f; n <= t; n += s) out.push(fmt(n / mul));
    return out;
  }
  var signed = function (n) { return (n > 0 ? '+' : '') + n.toFixed(2); };

  function fillSelect(sel, values, placeholder, selected) {
    sel.innerHTML = '';
    var o0 = document.createElement('option');
    o0.value = ''; o0.textContent = placeholder; sel.appendChild(o0);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = String(v); o.textContent = String(v);
      if (selected !== undefined && String(v) === String(selected)) o.selected = true;
      sel.appendChild(o);
    });
  }

  /* ---------- rendering ---------- */
  function renderColors() {
    var wrap = $('[data-rx-colors]');
    wrap.innerHTML = '';
    if (!state.type) return;
    colorsFor(state.type).forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'rx-color';
      b.setAttribute('data-rx-color', v.color);
      b.setAttribute('aria-pressed', String(v.color === state.color));
      if (!v.available) b.disabled = true;
      b.innerHTML = '<b>' + v.color + '</b><i>' + money(v.price) + '</i>';
      wrap.appendChild(b);
    });
  }

  function updateHero() {
    var hero = root.querySelector('[data-rx-hero]');
    var name = root.querySelector('[data-rx-heroname]');
    var v = current();
    if (hero && v && v.img) hero.src = v.img;
    if (name && v) name.textContent = root.getAttribute('data-product-title') + ' \u00b7 ' + v.color;
  }

  function renderFromPrices() {
    $$('[data-rx-from]').forEach(function (el) {
      var c = cheapest(el.getAttribute('data-rx-from'));
      el.textContent = c ? 'From ' + money(c.price) : '';
    });
  }

  function renderManual() {
    var box = $('[data-rx-manual]');
    if (box.getAttribute('data-built') === '1') { toggleAdd(); return; }
    box.setAttribute('data-built', '1');

    var sph = range(-20, 12, 0.25, signed);
    var cyl = range(-6, 6, 0.25, signed);
    var axis = []; for (var a = 1; a <= 180; a++) axis.push(a);
    var add = range(0.75, 3.5, 0.25, signed);

    ['OD', 'OS'].forEach(function (eye) {
      var h = document.createElement('p');
      h.className = 'rx-eyelabel';
      h.textContent = eye === 'OD' ? 'Right eye (OD)' : 'Left eye (OS)';
      box.appendChild(h);

      var g = document.createElement('div'); g.className = 'rx-grid';
      [['Sphere', sph, '0.00'], ['Cylinder', cyl, '0.00'], ['Axis', axis, ''], ['Add', add, '']]
        .forEach(function (f) {
          var name = eye + ' ' + f[0];
          var d = document.createElement('div'); d.className = 'rx-field';
          if (f[0] === 'Add') d.setAttribute('data-rx-addrow', '1');
          var id = 'Rx' + eye + f[0];
          d.innerHTML = '<label for="' + id + '">' + f[0] + '</label>';
          var s = document.createElement('select');
          s.id = id; s.setAttribute('data-rx-input', name);
          fillSelect(s, f[1], f[0] === 'Axis' ? 'Not needed' : 'Select', f[2]);
          if (f[2]) state.values[name] = f[2];
          if (f[0] === 'Axis') s.disabled = true;
          d.appendChild(s); g.appendChild(d);
        });
      box.appendChild(g);
    });

    // No expiration date. Asking for one blocked anyone whose prescription had
    // run out, which is a sale lost over a date the lab does not act on anyway.
    // The shopper attests the values instead.
    var attest = document.createElement('label');
    attest.className = 'rx-attest';
    attest.innerHTML = '<input type="checkbox" id="RxAttest" data-rx-attest>' +
      '<span>I confirm that this information is correct and taken from a valid prescription.</span>';
    box.appendChild(attest);

    var lead = document.createElement('p');
    lead.className = 'rx-lead';
    lead.textContent = 'Prescription lenses are made to order and take 2 to 3 weeks before they ship.';
    box.appendChild(lead);

    toggleAdd();
  }

  // Add row: required for Progressive, optional for Reading, hidden for Everyday
  function toggleAdd() {
    var show = state.use === 'Progressive' || state.use === 'Reading';
    $$('[data-rx-addrow]').forEach(function (d) { d.hidden = !show; });
  }

  function renderPd() {
    var singles = [], duals = [];
    for (var n = 40; n <= 80; n += 0.5) singles.push(n.toFixed(1).replace('.0', ''));
    for (var m = 20; m <= 40; m += 0.5) duals.push(m.toFixed(1).replace('.0', ''));
    var s = $('#RxPdSingle'); if (s && !s.options.length) fillSelect(s, singles, 'Select');
    var r = $('#RxPdRight'); if (r && !r.options.length) fillSelect(r, duals, 'Select');
    var l = $('#RxPdLeft'); if (l && !l.options.length) fillSelect(l, duals, 'Select');

    $('[data-rx-pd-single]').hidden = state.pdType !== 'Single';
    $('[data-rx-pd-dual]').hidden = state.pdType !== 'Dual';
    $('[data-rx-pdfields]').hidden = state.pdType === 'On Rx';
    $('[data-rx-accupd]').hidden = state.pdType === 'On Rx';
    // "PD is on my Rx" only makes sense when a file was uploaded
    $('[data-rx-onrx]').hidden = state.method !== 'Upload';
  }

  /* ---------- Uploadery ----------
     Uploadery inserts #uploadery-container after an add to cart button and uploads the file
     as soon as it is chosen, writing the S3 URL into a hidden properties[prescription] input.
     We relocate its container into the Upload step and read that input at add to cart. */
  function rxFileInput() {
    return document.querySelector('input[name="properties[prescription]"]');
  }
  function uploadedUrl() {
    var i = rxFileInput();
    return i && i.value ? i.value : '';
  }
  function mountUploadery(tries) {
    tries = tries || 0;
    var mount = $('[data-rx-uploadery-mount]');
    if (!mount) return;
    var c = document.getElementById('uploadery-container');
    if (c) {
      if (c.parentNode !== mount) mount.appendChild(c);
      var err = $('[data-rx-uploaderr]'); if (err) err.hidden = true;
      // Uploadery writes the hidden input on upload completion; poll for it
      if (!mount.getAttribute('data-watch')) {
        mount.setAttribute('data-watch', '1');
        setInterval(function () {
          var url = uploadedUrl();
          var fn = $('[data-rx-filename]');
          if (url) {
            var name = decodeURIComponent(url.split('/').pop().replace(/^[0-9a-f]{6,}-/i, ''));
            if (fn) { fn.hidden = false; fn.textContent = 'Attached: ' + name; }
          } else if (fn) { fn.hidden = true; }
          if (state.step === 3 && state.method === 'Upload') sync();
        }, 700);
      }
      return;
    }
    if (tries < 40) { setTimeout(function () { mountUploadery(tries + 1); }, 400); return; }
    var e = $('[data-rx-uploaderr]'); if (e) e.hidden = false;
  }

  /* ---------- validation ---------- */
  function stepValid() {
    if (state.step === 1) return !!current() && current().available;
    if (state.step === 2) return true;
    if (state.step === 3) {
      if (state.method === 'Send later') return true;
      if (state.method === 'Upload') return !!uploadedUrl();
      if (state.method === 'Manual') {
        var need = ['OD Sphere', 'OS Sphere'];
        for (var i = 0; i < need.length; i++) if (!state.values[need[i]]) return false;
        // axis required whenever cylinder is not zero
        var eyes = ['OD', 'OS'];
        for (var e = 0; e < eyes.length; e++) {
          var c = state.values[eyes[e] + ' Cylinder'];
          if (c && parseFloat(c) !== 0 && !state.values[eyes[e] + ' Axis']) return false;
          if (state.use === 'Progressive' && !state.values[eyes[e] + ' Add']) return false;
        }
        return !!state.attest;
      }
      return false;
    }
    if (state.step === 4) {
      if (state.pdType === 'On Rx') return true;
      if (state.pdType === 'Single') return !!state.values['Single PD'];
      return !!state.values['Right PD'] && !!state.values['Left PD'];
    }
    return false;
  }

  function sync() {
    $$('[data-rx-step]').forEach(function (s) {
      s.hidden = parseInt(s.getAttribute('data-rx-step'), 10) !== state.step;
    });
    $$('.rx-progress span').forEach(function (s, i) { s.classList.toggle('is-done', i < state.step); });
    var t = total();
    $('[data-rx-total]').textContent = t === null ? '—' : money(t);
    var next = $('[data-rx-next]');
    next.textContent = state.step === 4 ? 'Add to cart' : 'Continue';
    next.disabled = !stepValid();
    $('[data-rx-back]').hidden = state.step === 1;
    var err = $('[data-rx-err]');
    if (err) {
      var v = current();
      var bad = state.step === 1 && v && !v.available;
      err.hidden = !bad;
      if (bad) err.textContent = 'That lens color is sold out in this type. Pick another.';
    }
    fitHero();
  }

  /* No scrolling on a phone: the step has to fit between the hero and the
     Continue bar. Products carry different numbers of lens colors (9 on most,
     10 on A Phase), so instead of tuning the CSS per product we give the hero
     back whatever space the step is short of, down to a floor that still shows
     the frame clearly. */
  var HERO_FLOOR = 92;

  /* How much empty room the step has below its content. scrollHeight is no use
     here: on a flex item it is clamped to the item's own height, so it reports
     zero spare however short the content is. The last child's bottom edge is the
     real answer. Negative means the content overflows by that much. */
  function contentSlack(step) {
    var kids = step.children;
    var bottom = null;
    for (var i = kids.length - 1; i >= 0; i--) {
      if (kids[i].offsetParent === null && kids[i].hidden) continue;
      var r = kids[i].getBoundingClientRect();
      if (r.height === 0) continue;
      if (bottom === null || r.bottom > bottom) bottom = r.bottom;
    }
    if (bottom === null) return 0;
    var box = step.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(step).paddingBottom) || 0;
    return Math.round(box.bottom - pad - bottom);
  }
  function fitHero() {
    var sheet = document.querySelector('[data-rx-overlay]');
    if (sheet && sheet.hidden) return;   // nothing measures while it is closed
    var hero = $('.rx-hero');
    if (!hero) return;
    hero.style.height = '';
    hero.style.minHeight = '';
    hero.style.maxHeight = '';
    if (window.matchMedia('(min-width:769px)').matches) return;
    var step = $('[data-rx-step]:not([hidden])');
    if (!step) return;
    hero.style.minHeight = '0px';
    hero.style.maxHeight = 'none';

    // Adjust from the height it is already showing. Collapsing to the floor first
    // would measure cleanly but flashes a small image on open, since the first
    // frames after unhiding still report the pre-layout box.
    var h = hero.getBoundingClientRect().height;
    var slack = contentSlack(step);

    // documentElement.clientHeight, not window.innerHeight: the latter reports the
    // browser chrome's own box inside preview panes and reads as 0 there.
    var vh = document.documentElement.clientHeight || 800;
    var ceiling = Math.round(vh * 0.40);
    hero.style.height = Math.max(HERO_FLOOR, Math.min(ceiling, h + slack)) + 'px';
  }
  window.addEventListener('resize', fitHero);

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b || b.disabled) return;

    if (b.hasAttribute('data-rx-use')) {
      state.use = b.getAttribute('data-rx-use');
      state.type = b.getAttribute('data-rx-variant-type');
      $$('[data-rx-use]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var keep = state.color && find(state.type, state.color);
      if (!keep) state.color = null;
      renderColors(); toggleAdd(); sync(); return;
    }
    if (b.hasAttribute('data-rx-color')) {
      state.color = b.getAttribute('data-rx-color');
      $$('[data-rx-color]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      updateHero(); sync(); return;
    }
    if (b.hasAttribute('data-rx-material')) {
      state.material = b.getAttribute('data-rx-material');
      $$('[data-rx-material]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      sync(); return;
    }
    if (b.hasAttribute('data-rx-method')) {
      state.method = b.getAttribute('data-rx-method');
      $$('[data-rx-method]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      $$('[data-rx-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-rx-panel') !== state.method;
      });
      if (state.method === 'Manual') renderManual();
      if (state.method === 'Upload') mountUploadery(0);
      if (state.method !== 'Upload' && state.pdType === 'On Rx') state.pdType = 'Single';
      sync(); return;
    }
    if (b.hasAttribute('data-rx-pdtype')) {
      state.pdType = b.getAttribute('data-rx-pdtype');
      $$('[data-rx-pdtype]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      renderPd(); sync(); return;
    }
    if (b.hasAttribute('data-rx-back')) {
      if (state.step > 1) { state.step--; sync(); }
      return;
    }
    if (b.hasAttribute('data-rx-next')) {
      if (!stepValid()) return;
      if (state.step < 4) {
        state.step++;
        if (state.step === 4) renderPd();
        sync();
      } else {
        addToCart(b);
      }
    }
  });

  root.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-rx-attest')) {
      state.attest = el.checked;
      sync();
      return;
    }
    if (!el.hasAttribute || !el.hasAttribute('data-rx-input')) return;
    var key = el.getAttribute('data-rx-input');
    state.values[key] = el.value;

    // axis only enabled when cylinder is non zero
    var m = key.match(/^(OD|OS) Cylinder$/);
    if (m) {
      var ax = $('#Rx' + m[1] + 'Axis');
      if (ax) {
        var on = el.value && parseFloat(el.value) !== 0;
        ax.disabled = !on;
        if (!on) { ax.value = ''; delete state.values[m[1] + ' Axis']; }
      }
    }
    sync();
  });

  /* ---------- add to cart ---------- */
  function groupId() {
    try { return crypto.randomUUID().slice(0, 8); }
    catch (e) { return Math.random().toString(16).slice(2, 10); }
  }

  function buildProperties(group) {
    var p = {
      'Lens Use': state.use,
      'Lens Material': state.material,
      'Rx Method': state.method,
      'PD Type': state.pdType,
      '_rx_group': group,
      '_rx_builder': 'v2'
    };
    if (state.method === 'Upload') {
      var u = uploadedUrl();
      if (u) p['prescription'] = u;
    }
    if (state.method === 'Manual') {
      ['OD Sphere','OD Cylinder','OD Axis','OS Sphere','OS Cylinder','OS Axis']
        .forEach(function (k) { if (state.values[k]) p[k] = state.values[k]; });
      p['Rx Attestation'] = 'Customer confirmed the values are correct and taken from a valid prescription';
      if (state.use === 'Progressive' || state.use === 'Reading') {
        ['OD Add','OS Add'].forEach(function (k) { if (state.values[k]) p[k] = state.values[k]; });
      }
    }
    if (state.pdType === 'Single' && state.values['Single PD']) p['Single PD'] = state.values['Single PD'];
    if (state.pdType === 'Dual') {
      if (state.values['Right PD']) p['Right PD'] = state.values['Right PD'];
      if (state.values['Left PD']) p['Left PD'] = state.values['Left PD'];
    }
    return p;
  }

  function addToCart(btn) {
    var v = current();
    if (!v) return;
    btn.disabled = true;
    var group = groupId();
    var items = [{ id: v.id, quantity: 1, properties: buildProperties(group) }];
    if (state.material === 'Trivex' && TRIVEX_ID) {
      items.push({
        id: TRIVEX_ID, quantity: 1,
        properties: {
          'Applies To': root.getAttribute('data-product-title') + ' / ' + v.type + ' / ' + v.color,
          '_rx_group': group
        }
      });
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
          window.Rebuy.SmartCart.show();
        } else {
          document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
          window.location.href = '/cart';
        }
        btn.disabled = false;
      })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------- lens color row on the product page ----------
     Lives outside #RxBuilder (it sits in the buy box), so it is wired from the document.
     Clicking a color previews it in the gallery and preselects it inside the builder. */
  var preColor = null;

  function baseName(u) {
    var f = String(u || '').split('?')[0].split('/').pop();
    return f.replace(/\.[a-z0-9]+$/i, '').replace(/_(\d+)?x(\d+)?$/i, '');
  }

  function showInGallery(imgUrl) {
    if (!imgUrl) return;
    var want = baseName(imgUrl);
    var slides = [].slice.call(document.querySelectorAll('.product-image-main'));
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('img');
      var src = im && (im.getAttribute('data-src') || im.currentSrc || im.src);
      if (im && baseName(src) === want) {
        try {
          var $ = window.jQuery;
          var slider = slides[i].closest('.slick-slider');
          if ($ && slider && $(slider).slick) {
            var slide = slides[i].closest('.slick-slide');
            var idx = slide ? parseInt(slide.getAttribute('data-slick-index'), 10) : -1;
            if (!isNaN(idx) && idx >= 0) { $(slider).slick('slickGoTo', idx); return; }
          }
        } catch (e) { /* fall through to scroll */ }
        slides[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        return;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-rx-lens]') : null;
    if (!b) return;
    preColor = b.getAttribute('data-rx-lens');
    [].slice.call(document.querySelectorAll('[data-rx-lens]')).forEach(function (x) {
      x.setAttribute('aria-pressed', String(x === b));
    });
    showInGallery(b.getAttribute('data-rx-lens-img'));
  });

  /* ---------- overlay ---------- */
  var overlay = document.querySelector('[data-rx-overlay]');
  function openBuilder() {
    if (!overlay) return;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    mountUploadery(0);
    // Heights only measure once the overlay is visible, and the first frame after
    // unhiding still reports the pre-layout box, so fit again on the frame after
    // that and once more when the hero image has decoded.
    requestAnimationFrame(function () {
      fitHero();
      requestAnimationFrame(fitHero);
    });
    var img = $('[data-rx-hero]');
    if (img && !img.complete) img.addEventListener('load', fitHero, { once: true });
    setTimeout(fitHero, 350);
    // carry the color chosen on the product page into step 1
    if (preColor && state.color !== preColor) {
      if (!state.type) {
        var first = root.querySelector('[data-rx-use="Distance"]');
        if (first) first.click();
      }
      if (find(state.type, preColor)) {
        state.color = preColor;
        $$('[data-rx-color]').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x.getAttribute('data-rx-color') === preColor));
        });
        updateHero();
        sync();
      }
    }
    var h = root.querySelector('.rx-h'); if (h) h.setAttribute('tabindex', '-1'), h.focus();
  }
  function closeBuilder() {
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-rx-open]') : null;
    if (o) { e.preventDefault(); openBuilder(); return; }
    var c = e.target.closest ? e.target.closest('[data-rx-close]') : null;
    if (c) { closeBuilder(); return; }
    if (overlay && e.target === overlay) closeBuilder();   // click the backdrop
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && !overlay.hidden) closeBuilder();
  });

  /* ---------- init ---------- */
  // Default to Everyday + the cheapest in-stock color so step 1 reads as a complete
  // choice and the running total shows a real price straight away. The shopper can
  // change either; anything picked on the product page still wins when the sheet opens.
  (function preselect() {
    var btn = root.querySelector('[data-rx-use="Distance"]');
    if (!btn) return;
    state.use = 'Distance';
    state.type = btn.getAttribute('data-rx-variant-type');
    $$('[data-rx-use]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
    var pick = null;
    colorsFor(state.type).forEach(function (v) {
      if (v.available && (!pick || v.price < pick.price)) pick = v;
    });
    if (pick) state.color = pick.color;
  })();

  renderFromPrices();
  renderColors();
  updateHero();
  mountUploadery(0);   // start early so the widget is ready before step 3
  sync();
})();
